import React,  { useState, useEffect } from 'react';
import axios from 'axios';
import {FormControl , TextField, Grid , Box, Card, CardContent , Typography,CardActions,Button,Alert ,Divider } from '@mui/material/';
import { DataGrid, GridToolbar  } from '@mui/x-data-grid';
import { propsToClassKey } from '@mui/material/styles';


import Lst_member_radier from './lst_membre_ofc_radier_datagrid'
import Lst_member_ajouter from './lst_membre_ofc_ajouter_datagrid'
import Cookies from 'js-cookie'

import Lst_member_annee from './components/lst_membre_annee'
import Rapport_annuel from './rapport_annuel'

import Rapport_annuel_total from './rapport_annuel_total'
import { getUserRule} from '../../utils/userRule';
import Autorize from '../ui/autorize';

//https://react-data-table-component.netlify.app/?path=/docs/examples-filtering--filtering
function Listsecteur({annee,reportname}) {

    const [autorize, setAutorize] = useState("false");
    const [errorAxios, setErrorAxios] = useState("false");

    const [clublist, setList] = useState([]);
    const [listSecteur, setListSecteur] = useState("");
   
    
  /*
    const MyAxios = axios.create({
        headers: { 'Access-Control-Allow-Origin':  process.env.REACT_APP_API},       
        withCredentials: true,
        xsrfCookieName: 'token',
        xsrfHeaderName: 'X-XSRF-TOKEN',
    })*/
const MyAxios = axios.create({    
    headers: { Authorization: "Bearer "+ Cookies.get('token'),
            }      
})

    useEffect(() => {
        

        const fetchData = async () => {
            try {

                let RuleReport = await getUserRule("read_reports",sessionStorage.getItem('clubId'),sessionStorage.getItem('secteur'));
                setAutorize(RuleReport);

            } catch (error) {
                console.error('Une erreur s\'est produite lors de la récupération des données', error);
              }
        };
        fetchData(); // Appel de la fonction asynchrone
        


          if(autorize)
          {
                MyAxios.get(process.env.REACT_APP_API + '/clubs/getallsecteur') //axios.defaults.withCredentials = true
                .then((res) => {      
                    setErrorAxios(false);
                    //console.log(res);
                    setListSecteur(res.data);
                
                })
                .catch((error) => {
                    console.log(error)  
                ///  if(error.status) 
                  setErrorAxios(true);
                if(error.response.status === 401)// pas autorisé
                    setErrorAxios(true); 

                });

          }  
    },[annee,reportname]);
   
    function TT(value) 
    {
      //console.log("------------------",value);
      //console.log( " **** " ,  myAnnee);
        if(reportname == "getReportCompletAnneeEffectif") // le gros rapport de fin d'année
            return  <Rapport_annuel  key={value.Default_DistrictNbr} secteur={value.Default_DistrictNbr} annee={annee} />;       
        else if(reportname == "MembreRadierMois") //***************** utile */
           return  <Lst_member_radier  key={value.Default_DistrictNbr} secteur={value.Default_DistrictNbr} annee={annee}  reportname={reportname} />;
        else if(reportname == "MembreAjouterMois")
           return  <Lst_member_ajouter  key={value.Default_DistrictNbr} secteur={value.Default_DistrictNbr} annee={annee}  reportname={reportname} />;
        else
           return  <Lst_member_annee  key={value.Default_DistrictNbr} secteur={value.Default_DistrictNbr} annee={annee}  reportname={reportname} />;
                  
    }

   //  <Lst_member_annee  key={value.Default_DistrictNbr} secteur={value.Default_DistrictNbr} annee={annee}  reportname={reportname} />
//  {JSON.stringify(this.state.currentMember, null, 2) }     {Table}
  

        
        return (
             <div>
                     <Autorize axiosError={errorAxios} />
                     
                {Object.entries(listSecteur).map(([key, value]) => (
                    <Grid container spacing={2}>                          
                        <Grid item xs={8}> 
                             <Alert icon={false} severity="info">Secteur { value.Default_DistrictNbr }</Alert>
                        </Grid>

                        <Grid item xs={12}> 

                            {TT(value)}
                      
                        </Grid>
                        <Divider color="#FDA228" sx={{ height: 2, width: '98%', margin: '10px' }} />
                    </Grid>                     
                ))}


                <Rapport_annuel_total  key="TotalReport" annee={annee} />;

                
                </div>
     );

};

export default Listsecteur;